import { forwardRef } from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

export const Markdown = forwardRef<
	HTMLDivElement,
	{ children: string; className?: string }
>(({ children, className }, ref) => {
	return (
		<div
			ref={ref}
			className={`text-sm [&_h3]:text-lg sm:[&_h3]:text-xl md:[&_h3]:text-2xl sm:[&_h4]:text-base md:[&_h4]:text-lg [&_a]:text-sky-800 [&_ol_li]:list-decimal [&_ul_li]:list-disc [&_li]:list-inside [&_li_p]:inline-block [&_li_p]:mt-2 [&_ul]:has-[p]:mt-0 [&>*]:mt-2 first:[&>*]:mt-0 ${className}`}>
			<ReactMarkdown rehypePlugins={[rehypeRaw]}>{children}</ReactMarkdown>
		</div>
	);
});
